<template>
  <div class="gang-sheet-builder-container">
    <Sizes />
    <Variants />
    <GangSheetBuilderButton />
    <UploadGangSheet :current-store="currentStore" />
  </div>
</template>

<script>
import Sizes from "./Sizes.vue";
import Variants from "./Variants.vue";
import GangSheetBuilderButton from "./GangSheetBuilderButton.vue";
import UploadGangSheet from "./UploadGangSheet.vue";

export default {
  name: "GangSheetBuilderPdpContainer",
  components: {
    Sizes,
    Variants,
    GangSheetBuilderButton,
    UploadGangSheet
  },
  props: {
    currentStore: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
.gang-sheet-builder-container {
  position: relative;
}
</style>
